<template>
  <w-sliding-popup type="full" ref="slidingPopup" title="저장소 구성" top="50px" :appendToBody="true">
    <div class="tab-wrapper" slot="content">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="저장소" name="dataindex">
          <w-log-index-store ref="indexStore" :activeTab="activeTab"></w-log-index-store>
        </el-tab-pane>
        <el-tab-pane label="파일" name="file">
          <w-log-file-store :activeTab="activeTab"></w-log-file-store>
        </el-tab-pane>
      </el-tabs>
    </div>
  </w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import WLogFileStore from './LogFileStore';
import WLogIndexStore from './LogIndexStore';

export default {
  name: 'WLogStoreStructure',
  components: {
    WLogFileStore,
    WLogIndexStore,
  },
  data() {
    return {
      activeTab: 'dataindex',
    };
  },
  methods: {
    open() {
      this.activeTab = 'dataindex';
      this.$refs.slidingPopup.open();
      if (!isEmpty(this.$refs.indexStore)) {
        this.$refs.indexStore.loadData();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/popup/store/index.vue